import {
  useDeleteInteractionsByTripByTripIdCommentAndCommentIdMutation,
  useGetProfilesByUserIdQuery,
} from '../../../store/backendApi';
import { Button } from '../../../components/Button';

export interface CommentProps {
  id: string;
  name?: string;
  userId?: string;
  body: string;
  timeText: string;
  tripId: string;
  isOwner: boolean;
}

export const Comment = (props: CommentProps) => {
  const { data: profileData } = useGetProfilesByUserIdQuery(props.userId ?? '', {
    skip: !props.userId,
  });

  const [deleteComment] = useDeleteInteractionsByTripByTripIdCommentAndCommentIdMutation();

  const displayName = props.name || profileData?.username || 'Anonymous';

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      await deleteComment({
        tripId: props.tripId,
        commentId: props.id,
      });
    }
  };

  return (
    <div className="flex gap-3 items-start w-full group">
      {/* Avatar */}
      <div className="flex-shrink-0 mt-1">
        {props.userId ? (
          <a
            href={`/profile/${props.userId}`}
            className="inline-block rounded-full w-8 h-8 overflow-hidden bg-muted hover:opacity-80 transition-opacity"
          >
            <img
              className="w-full h-full object-cover"
              alt={displayName}
              src={`https://media.${process.env.REACT_APP_HOST}/users/${
                props.userId
              }-thumbnail.jpg?v=${Date.now()}`}
              onError={(e) => {
                // Fallback to default avatar if image fails to load
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.innerHTML = `
                    <svg fill="currentColor" viewBox="0 0 24 24" class="w-full h-full text-disabled">
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354
                      11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                  `;
                }
              }}
            />
          </a>
        ) : (
          <span className="inline-block rounded-full w-8 h-8 overflow-hidden bg-muted">
            <svg fill="currentColor" viewBox="0 0 24 24" className="w-full h-full text-disabled">
              <path
                d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996
                    5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </span>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="text-sm">
          {props.userId ? (
            <a
              href={`/profile/${props.userId}`}
              className="font-bold text-main hover:text-brand transition-colors mr-1"
            >
              {displayName}
            </a>
          ) : (
            <span className="font-bold text-main mr-1">{displayName}</span>
          )}
          <span className="text-main break-words">{props.body}</span>
        </div>
        <div className="mt-1 flex items-center gap-3 text-xs text-muted">
          <span>{props.timeText}</span>
          {props.isOwner && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDelete}
              className="font-semibold p-0 h-auto"
            >
              Delete
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
